import { instance } from "./../../axios/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const communicateBack = createAsyncThunk(
  "communication-form/communicateBack",
  async (
    {
      clientId,
      employee,
      recid,
      employeeName,
      employeePhone,
      phone,
      email,
      bodytext,
      communication_type,
      lastcommsdate,
      comm_mode,
    },
    { rejectWithValue }
  ) => {
    try {
      console.log( {
        clientId,
        employee,
        recid,
        employeeName,
        employeePhone,
        phone,
        email,
        bodytext,
        communication_type,
        lastcommsdate,
        comm_mode,
      })
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post("comm/portal/communication-form/communicate-back",
        {
          clientId,
          employee,
          recid,
          employeeName,
          employeePhone,
          phone,
          email,
          bodytext,
          communication_type,
          lastcommsdate,
          comm_mode,
        },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const communicateBackCancelledServices = createAsyncThunk(
  "communication-form/communicateBackCancelledServices",
  async (
    {
      clientId,
      employee,
      recid,
      employeeName,
      employeePhone,
      phone,
      email,
      bodytext,
      communication_type,
      lastcommsdate,
      comm_mode,
      direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post(
        "/comm/portal/communication-form/communicate-back-cancelled-service",
        {
          clientId,
          employee,
          recid,
          employeeName,
          employeePhone,
          phone,
          email,
          bodytext,
          communication_type,
          lastcommsdate,
          comm_mode,
          direction,
        },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
